module.exports = __webpack_public_path__ + "img/max-file-edit--json.494a876e.svg";